import { v4 as uuidv4 } from 'uuid';
import { useContext, useEffect } from "react";
import { litController, socket } from "../../utils/init";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../Loader";
import NavContext from "../../NavContext";
import keyringController from "../../utils/init";
import { eventTypes } from "@tria-sdk/connect";
import { useParams } from "react-router-dom";
import { checkBrowser } from "../../utils/helper";

const Callback = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const param = useParams();
  const navigate = useNavigate();
  const { setLitLoginType ,setUserEmail} = useContext(NavContext);

  useEffect(() => {
    authenticate();
    console.log("idtoken", searchParams.get("id_token"));
    localStorage.setItem("idToken", searchParams.get("id_token") || "");
  }, []);

  const authenticate = async () => {
    try {
      const state = searchParams.get('state') ||"";
      const redirect=searchParams.get('redirect') || false;
      const access_denied= searchParams.get('error') === 'access_denied';
      console.log("access_denied",access_denied);
      if(!redirect){
        let socketId= "";
        if (state && typeof state === 'string') {
          socketId =JSON.parse(Buffer.from(state, 'base64').toString('utf-8'))?.socketId;
      }
        const currentURL = window.location.href;

        const urlWithRedirectParam = new URL(currentURL);
        urlWithRedirectParam.searchParams.append("redirect", "true");
        const updatedURL = urlWithRedirectParam.href;

        if(access_denied){
          window.close();
          return;
       }
     
        socket.emit("loginV2", {
          userId: socketId,
      }, () => { // Callback function to ensure the room is joined before emitting messageV2
          socket.emit("messageV2", {
              userId: socketId,
              message: updatedURL
          }, () => { // Callback function to close the window after emitting messageV2
            window.close();
          });
      });
      return;
      }
      if(access_denied){
         window.parent.location.reload();
      }
      console.log("call authenticate with lit");
      if (param?.social === "google") {
        const redirectUri=`${window.location.origin}/callback/google`;
        const auth = await litController?.authenticateWithGoogle(redirectUri);
        if (!auth) {
          throw new Error("auth undefined");
        }
        localStorage.setItem(
          "customAuthMethod",
          JSON.stringify(auth.authMethod)
        );
        localStorage.setItem("accessToken", auth.accessToken);
        //@ts-ignore
        setUserEmail(auth?.authMethod?.userKey);
        console.log("authMethod", auth);
        //@ts-ignore
        const pkp = await litController?.getPKPs(auth.authMethod);
        console.log("pkp response", pkp);
        if (pkp?.length === 0) {
          setLitLoginType("social");
          navigate("/signup/lit");
          // keyringController.postMessage(
          //   {
          //     type: eventTypes.passMessage,
          //     message: {
          //       accountExists: false,
          //       social: "google",
          //     },
          //   },
          //   true
          // );
        } else {
          //@ts-ignore
          console.log("pkp----", pkp[0]);
          const init = await litController?.initSession({
            //@ts-ignore
            authMethod: auth?.authMethod,
            pkp: pkp[0],
            socialName: "google",
            chain: "MUMBAI",
            triaName: "",
            isNewUser: false,
            type: "social",
            //@ts-ignore
            uuid: auth?.authMethod?.userOauthId,
          });

          localStorage.setItem(
            "currentAccount",
            JSON.stringify(pkp[pkp.length - 1])
          );
          console.log("init", init);
        }
        // window.close();
      } else if (param?.social === "discord") {
        const auth = await litController?.authenticateWithDiscord();
        if (!auth) {
          throw new Error("auth undefined");
        }
        //@ts-ignore
        localStorage.setItem(
          "customAuthMethod",
            //@ts-ignore
          JSON.stringify(auth.authMethod)
        );
        //@ts-ignore
        localStorage.setItem("accessToken", auth?.accessToken);
        //@ts-ignore
        setUserEmail(auth?.authMethod?.userKey);
        console.log("authMethod", auth);
        //@ts-ignore
        const pkp = await litController?.getPKPs(auth.authMethod);
        console.log("pkp response", pkp);
        if (pkp?.length === 0) {
          setLitLoginType("social");
          navigate("/signup/lit");
        } else {
          //@ts-ignore
          console.log("pkp----", pkp[0]);
          const init = await litController?.initSession({
            //@ts-ignore
            authMethod: auth.authMethod,
            pkp: pkp[0],
            socialName: "discord",
            chain: "MUMBAI",
            triaName: "",
            isNewUser: false,
            type: "social",
            //@ts-ignore
            uuid: auth?.authMethod?.userOauthId,
          });
          localStorage.setItem(
            "currentAccount",
            JSON.stringify(pkp[pkp.length - 1])
          );
          console.log("init res", init);
        }
      } else if (param?.social === "twitter") {
        const auth = await litController?.authenticateWithTwitter();
        if (!auth) {
          throw new Error("auth undefined");
        }
        localStorage.setItem(
          "customAuthMethod",
          //@ts-ignore
          JSON.stringify(auth?.authMethod)
        );
        localStorage.setItem("accessToken", auth?.accessToken);
        //@ts-ignore
        setUserEmail(auth?.authMethod?.userKey);
        console.log("authMethod", auth);
        //@ts-ignore
        const pkp = await litController?.getPKPs(auth.authMethod);
        console.log("pkp response", pkp);
        if (pkp?.length === 0) {
          setLitLoginType("social");
          navigate("/signup/lit")
          // keyringController.postMessage(
          //   {
          //     type: eventTypes.passMessage,
          //     message: {
          //       accountExists: false,
          //       social: "twitter",
          //     },
          //   },
          //   true
          // );
        } else {
          //@ts-ignore
          console.log("pkp----", pkp[0]);
          const init = await litController?.initSession({
            //@ts-ignore
            authMethod: auth.authMethod,
            pkp: pkp[0],
            socialName: "twitter",
            chain: "MUMBAI",
            triaName: "",
            isNewUser: false,
            type: "social",
            //@ts-ignore
            uuid: auth?.authMethod?.userOauthId,
          });
          localStorage.setItem(
            "currentAccount",
            JSON.stringify(pkp[pkp.length - 1])
          );
          console.log("init", init);
        }
        // window.close();
      }
    } catch (err) {
console.log(err);
    }
  };

  return (
    <>
      <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <Loader />
      </div>
    </>
  );
};

export default Callback;
